import { createJSONStorage, persist } from 'zustand/middleware';
import { Policy } from '../generated/gql-types';
import { policyActions } from './policy.action';
import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

type PolicyStore = {
  // States
  policies: Policy[];
  setPolicies: (policies: Policy[]) => void;

  // Actions
  fetchPoliciesByOwnerId: (ownerId: string) => Promise<Policy[]>;
  agreeToPolicy: (policyId: string) => Promise<Policy>;

  // Getters
  getPolicyByType: (policyType: any) => Policy[];
};

export const usePolicyStore = create<PolicyStore>()(
  persist(
    (set, get) => ({
      // States
      policies: [],
      setPolicies: (policies: Policy[]) => set({ policies }),

      // Actions
      fetchPoliciesByOwnerId: async (ownerId: string) => {
        const policies = await policyActions.getPoliciesByOwnerId(ownerId);
        set({ policies });
        return policies;
      },
      agreeToPolicy: async (policyId: string) => {
        const updated = await policyActions.agreeToPolicy(policyId);
        const policies = get().policies;
        const index = policies.findIndex((row) => row.id === updated.id);
        // Replacement list for Zustand: upsert by id so we never keep a stale duplicate
        // row alongside the agreed mutation result (consumers often use [...][0]).
        const nextPolicies =
          index >= 0
            ? policies.map((row, i) => (i === index ? updated : row))
            : [...policies, updated];
        set({ policies: nextPolicies });
        return updated;
      },

      // Getters
      getPolicyByType: (policyType: any) => {
        return get().policies.filter(
          (policy) => policy.policyType === policyType,
        );
      },
    }),
    {
      name: 'policy-storage',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({ policies: state.policies }),
    },
  ),
);
